import cx from 'classnames';
import truncate from 'lodash-es/truncate';
import ProductCoverImage from 'mk2/apps/bazaar/components/ProductCoverImage';
import ProductFacets from 'mk2/apps/bazaar/components/ProductFacets';
import ProductStockStatus from 'mk2/apps/bazaar/components/ProductStockStatus';
import { ProductEntity } from 'mk2/apps/bazaar/schemas';
import { OverlayLoadable } from 'mk2/components/OverlayLoadable';
import { Popover } from 'mk2/components/Popover';
import useOverlay from 'mk2/hooks/useOverlay';
import React from 'react';
import styles from './ProductCoverImageWithPopover.mscss';

interface OwnProps {
    className?: string;
    product: ProductEntity;
    size?: number;
}

type Props = OwnProps;

const popperConfig = {
    modifiers: {
        offset: {
            enabled: true,
            offset: '0, 7px',
        },
    },
};

const ProductCoverImageWithPopover: React.FunctionComponent<Props> = ({ className, product, size = 40 }) => {
    const [
        showProductPopover,
        onProductImageMouseEnter,
        onProductImageMouseLeave,
        coverImageRef,
        getCoverImage,
        bodyContainer,
    ] = useOverlay<HTMLAnchorElement, HTMLDivElement>([500, 200]);

    const facets = product.properties.filter((p) => p[0] !== 'cat').map((p) => p[2]);

    return (
        <div
            className={cx(styles.ProductCoverImageWithPopover, className)}
            onMouseEnter={onProductImageMouseEnter}
            onMouseLeave={onProductImageMouseLeave}
        >
            <ProductCoverImage product={product} alt={product.seo.name} innerRef={coverImageRef} size={size} />
            <OverlayLoadable
                container={bodyContainer}
                show={showProductPopover}
                placement="top"
                target={getCoverImage}
                popperConfig={popperConfig}
            >
                {({ props, arrowProps, placement }) => (
                    <Popover
                        className={styles.ProductCoverImageWithPopover__popover}
                        placement={placement}
                        containerRef={props.ref}
                        style={props.style}
                        arrowRef={arrowProps.ref}
                        arrowStyle={arrowProps.style}
                    >
                        <div className={styles.ProductCoverImageWithPopover__popover__labels}>
                            <ProductFacets facets={facets} />
                            <ProductStockStatus stockStatus={product.stockStatus} />
                        </div>
                        <div className={styles.ProductCoverImageWithPopover__popover__description}>
                            {truncate(product.description, { length: 200 })}
                        </div>
                    </Popover>
                )}
            </OverlayLoadable>
        </div>
    );
};

ProductCoverImageWithPopover.displayName = 'ProductCoverImageWithPopover';

export default React.memo<Props>(ProductCoverImageWithPopover);
